import { useQuery, UseQueryResult } from "react-query"
import { CarrotPlanRecommendation } from "types/CarrotPlanOptions"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import { RetryConfig } from "utils/ErrorHandling"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const RECOMMENDATIONS_QUERY_KEY = "RECOMMENDATIONS_QUERY_KEY"

export function useCarrotPlanRecommendations(
  employeeId: number,
  journeyId?: number,
  journeyStageId?: number,
  enabled = true
): UseQueryResult<CarrotPlanRecommendation[]> {
  return useQuery({
    queryKey: [RECOMMENDATIONS_QUERY_KEY, employeeId, journeyId, journeyStageId],
    queryFn: () => client.getCarrotPlanRecommendations(employeeId, journeyId, journeyStageId),
    enabled,
    ...RetryConfig
  })
}
